// extracted by mini-css-extract-plugin
export var active = "AccountingPublishForm-module--active--LnPGy";
export var editDetailsOverlay = "AccountingPublishForm-module--editDetailsOverlay--QqeST";
export var editDetailsWrapper = "AccountingPublishForm-module--editDetailsWrapper--Nhgrf";